"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AminoConverter = void 0;
exports.AminoConverter = {
    "/ibc.core.client.v1.MsgCreateClient": {
        aminoType: "cosmos-sdk/MsgCreateClient",
        toAmino: ({ clientState, consensusState, signer }) => {
            return {
                client_state: {
                    type_url: clientState.typeUrl,
                    value: clientState.value
                },
                consensus_state: {
                    type_url: consensusState.typeUrl,
                    value: consensusState.value
                },
                signer
            };
        },
        fromAmino: ({ client_state, consensus_state, signer }) => {
            return {
                clientState: {
                    typeUrl: client_state.type_url,
                    value: client_state.value
                },
                consensusState: {
                    typeUrl: consensus_state.type_url,
                    value: consensus_state.value
                },
                signer
            };
        }
    },
    "/ibc.core.client.v1.MsgUpdateClient": {
        aminoType: "cosmos-sdk/MsgUpdateClient",
        toAmino: ({ clientId, header, signer }) => {
            return {
                client_id: clientId,
                header: {
                    type_url: header.typeUrl,
                    value: header.value
                },
                signer
            };
        },
        fromAmino: ({ client_id, header, signer }) => {
            return {
                clientId: client_id,
                header: {
                    typeUrl: header.type_url,
                    value: header.value
                },
                signer
            };
        }
    },
    "/ibc.core.client.v1.MsgUpgradeClient": {
        aminoType: "cosmos-sdk/MsgUpgradeClient",
        toAmino: ({ clientId, clientState, consensusState, proofUpgradeClient, proofUpgradeConsensusState, signer }) => {
            return {
                client_id: clientId,
                client_state: {
                    type_url: clientState.typeUrl,
                    value: clientState.value
                },
                consensus_state: {
                    type_url: consensusState.typeUrl,
                    value: consensusState.value
                },
                proof_upgrade_client: proofUpgradeClient,
                proof_upgrade_consensus_state: proofUpgradeConsensusState,
                signer
            };
        },
        fromAmino: ({ client_id, client_state, consensus_state, proof_upgrade_client, proof_upgrade_consensus_state, signer }) => {
            return {
                clientId: client_id,
                clientState: {
                    typeUrl: client_state.type_url,
                    value: client_state.value
                },
                consensusState: {
                    typeUrl: consensus_state.type_url,
                    value: consensus_state.value
                },
                proofUpgradeClient: proof_upgrade_client,
                proofUpgradeConsensusState: proof_upgrade_consensus_state,
                signer
            };
        }
    },
    "/ibc.core.client.v1.MsgSubmitMisbehaviour": {
        aminoType: "cosmos-sdk/MsgSubmitMisbehaviour",
        toAmino: ({ clientId, misbehaviour, signer }) => {
            return {
                client_id: clientId,
                misbehaviour: {
                    type_url: misbehaviour.typeUrl,
                    value: misbehaviour.value
                },
                signer
            };
        },
        fromAmino: ({ client_id, misbehaviour, signer }) => {
            return {
                clientId: client_id,
                misbehaviour: {
                    typeUrl: misbehaviour.type_url,
                    value: misbehaviour.value
                },
                signer
            };
        }
    }
};
//# sourceMappingURL=tx.amino.js.map